import { inject, Signal, signal } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { FreeformApiService } from "../services/freeform.api.service";
import { PollApiService } from "../services/poll.api.service";
import { Interactive } from "../models/interactive.model";
import { InteractiveFormSubmit } from "../models/interactive-form.model";
import { toCreateFreeformRequest, toCreatePollRequest } from "../mappers/interactive.mapper";
import { SnackbarService } from "../../components/snackbar/snackbar.service";

export interface CreateInteractive {
    readonly submitting: Signal<boolean>;
    submit(event: InteractiveFormSubmit): void;
}

export function injectCreateInteractive(errorMessage: string): CreateInteractive {
    const freeformApi = inject(FreeformApiService);
    const pollApi = inject(PollApiService);
    const router = inject(Router);
    const snackbarService = inject(SnackbarService);
    const submitting = signal(false);

    function submit({ value, targetState }: InteractiveFormSubmit): void {
        const request$: Observable<Interactive> =
            value.type === "poll"
                ? pollApi.create(toCreatePollRequest(value, targetState))
                : freeformApi.create(toCreateFreeformRequest(value, targetState));

        submitting.set(true);
        request$.subscribe({
            next: () => {
                snackbarService.show("Interactive created.", "success");
                void router.navigate(["/interactives"]);
            },
            error: () => {
                submitting.set(false);
                snackbarService.show(errorMessage, "error");
            }
        });
    }

    return { submitting: submitting.asReadonly(), submit };
}
